export enum currencies {
  USD = 'USD',
  UAH = 'UAH',
  EUR = 'EUR',
  ARS = 'ARS',
  MXN = 'MXN',
}
